import React, { useCallback, useEffect, useState, createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';
interface LanguageContextType {
  currentLanguage: string;
  setLanguage: (lang: string) => void;
  formatCurrency: (value: number, options?: Intl.NumberFormatOptions) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

// Exchange rates (example - should be updated with real-time data in production)
const EXCHANGE_RATES = {
  BRL: 5.5,
  USD: 1.0
};
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    i18n
  } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
  const setLanguage = useCallback((lang: string) => {
    i18n.changeLanguage(lang);
    setCurrentLanguage(lang);
    // You might want to persist the language preference
    localStorage.setItem('preferredLanguage', lang);
  }, [i18n]);
  const formatCurrency = useCallback((value: number, options?: Intl.NumberFormatOptions) => {
    const currency = currentLanguage === 'pt' ? 'BRL' : 'USD';
    const rate = EXCHANGE_RATES[currency];
    const formatter = new Intl.NumberFormat(currentLanguage === 'pt' ? 'pt-BR' : 'en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      ...options
    });
    return formatter.format(value * rate);
  }, [currentLanguage]);

  // Initialize language from localStorage on mount
  useEffect(() => {
    const savedLanguage = localStorage.getItem('preferredLanguage');
    if (savedLanguage && savedLanguage !== currentLanguage) {
      setLanguage(savedLanguage);
    }
  }, []);
  return <LanguageContext.Provider value={{
    currentLanguage,
    setLanguage,
    formatCurrency
  }} data-id="element-775">
      {children}
    </LanguageContext.Provider>;
}
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};